import { AuthLayout } from '../../components/auth';
import React from 'react';
import { ITabItem, Tab } from '../../components/common';
import { Outlet, useNavigate } from 'react-router-dom';
import LogoBlack from '../../components/LogoBlack';

const RegisterView = React.lazy(() =>
  import('../../components/auth').then((module) => ({
    default: module.RegisterView,
  })),
);
const LoginView = React.lazy(() =>
  import('../../components/auth').then((module) => ({
    default: module.LoginView,
  })),
);

interface Props {}

export const AuthPage: React.FC<Props> = () => {
  const navigate = useNavigate();

  const currentRoute = window.location.pathname;
  const initialTabIndex = currentRoute.endsWith('/login') ? 1 : 0;

  const handleTabChange = (item: ITabItem) => {
    if (item.id === 'register') {
      navigate('/auth/register');
    } else if (item.id === 'login') {
      navigate('/auth/login');
    }
  };

  return (
    <>
      <AuthLayout>
        <div className=' md:mt-[3em] lg:hidden 375:ml-[8em] 414:ml-[10em] 360:ml-[8em] 412:ml-[9em] 540:ml-[13em] bigmd:ml-[24em] mt-[2em] md:ml-[20em] md:w-[160px] '>
        <LogoBlack />
        </div>
       
        <Tab
          containerClass="mt-[2em] px-[16px] md:mt-[3em] lg:ml-[3em] xl:mt-[90px] xl:ml-[2em] 2xl:ml-[5em]"
          tabContainerClass="xl:w-[354px] xl:mb-3 md:w-[354px] xl:ml-[9em]"
          items={[
            {
              id: 'register',
              title: 'Register',
              component: <RegisterView />,
            },
            {
              id: 'login',
              title: 'Log in',
              component: <LoginView />,
            },
            
          ]}
          onChangeTab={handleTabChange}
          initialTabIndex={initialTabIndex} 
        />

        <Outlet />
      </AuthLayout>
    </>
  );
};
